<div class="container">
    <div class="toolbar set-flex-res">
        <div class="title-side accent">
            <h3 class="toolbar-title">{{ 'PAGE.ORDER.TITLE' | translate }}</h3>
            <small class="set-font-size">{{ 'PAGE.ORDER.DESCRIPTION' | translate }}</small>
        </div>
        <div class="tool-side set-visibility">
            <app-order-catogory-card class="order set-cursor" (click)="setStatus(''); resetPage(); onSearchChange()" icon="order" [title]="'ORDERS.ORDERS' | translate" [total]="totalOrder"></app-order-catogory-card>
            <app-order-catogory-card class="order set-cursor" (click)="setStatus('paid'); resetPage(); onSearchChange()" icon="paid_order" [title]="'ORDERS.PAID_ORDERS' | translate" [total]="totalPaid"></app-order-catogory-card>
            <app-order-catogory-card class="order set-cursor" (click)="setStatus('in_payment'); resetPage(); onSearchChange()" icon="inpayment_order" [title]="'ORDERS.INPAYMENT_ORDERS' | translate" [total]="totalInPayment"></app-order-catogory-card>
            <app-order-catogory-card class="order set-cursor" (click)="setStatus('unpaid'); resetPage(); onSearchChange()" icon="unpaid_order" [title]="'ORDERS.UNPAID_ORDERS' | translate" [total]="totalUnpaid"></app-order-catogory-card>
        </div>
    </div>
    <div class="mg-divider">
      <mat-divider></mat-divider>
    </div>
    <!-- <mat-divider></mat-divider> -->
    <div class="form-row order-filter" [formGroup]="searchDataGroup">

        <!-- Type -->
        <div class="form-group col-md-3">
            <div class="label">
                <label>{{'PAGE.ORDER.HOME.LIST.HEADER.PASS' | translate}}</label>
            </div>
            <mat-form-field class="mat-form-field input-group" appearance="outline" color="accent">
                <mat-select formControlName="type">
                    <mat-option *ngFor="let item of arrayTypes" [value]="item" (click)="resetPage();onSearchChange();">{{ "SYSTEM." + (item.id || 'ALL') | translate }}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <!-- Start Date -->
        <div class="form-group col-md-3">
            <div class="label">
                <label>{{'LABEL.LBL_START_DATE' | translate}}</label>
            </div>
            <div class="start_date">
                <mat-form-field appearance="outline" class="mat-form-field input-group" color="accent">
                    <input matInput [matDatepicker]="startDate" id="start_date" formControlName="start_date" (dateChange)="resetPage(); onSearchChange()">
                    <mat-datepicker-toggle matSuffix [for]="startDate"></mat-datepicker-toggle>
                    <mat-datepicker #startDate></mat-datepicker>
                </mat-form-field>
            </div>
        </div>

        <!-- End Date -->
        <div class="form-group col-md-3">
            <div class="label">
                <label>{{'LABEL.LBL_END_DATE' | translate}}</label>
            </div>
            <div class="end_date">
                <mat-form-field appearance="outline" class="mat-form-field input-group" color="accent">
                    <input matInput [matDatepicker]="endDate"
                      id="end_date"
                      formControlName="end_date"
                      [min]="searchDataGroup.get('start_date').value"
                      (dateChange)="resetPage(); onSearchChange()"
                    >
                    <mat-datepicker-toggle matSuffix [for]="endDate" ></mat-datepicker-toggle>
                    <mat-datepicker #endDate></mat-datepicker>
                </mat-form-field>
            </div>
        </div>

        <!-- Status -->
        <div class="form-group col-md-3">
            <div class="label">
                <label>{{'PAGE.ORDER.HOME.LIST.HEADER.STATUS' | translate}}</label>
            </div>
            <mat-form-field class="mat-form-field input-group" appearance="outline" color="accent">
                <mat-select formControlName="status">
                    <mat-option *ngFor="let item of arrayStatus"
                        [value]="item"
                        (click)="resetPage(); setStatus(item.id); onSearchChange(); status=item.id"
                    >
                        {{'PAGE.ORDER.HOME.LIST.' + item.code.toUpperCase() | translate}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="col-md-3 set-button-margin">
            <button mat-button (click)="onResetFilter()" class="set-btn-reset">
                {{ 'LABEL.RESET' | translate }}
            </button>
        </div>
    </div>

    <!-- <mat-divider></mat-divider> -->
    <!-- <div class="progress">
        <mat-progress-bar mode="query" *ngIf="loading" color="accent"></mat-progress-bar>
    </div> -->
    <div class="content">
            <!-- <p>HELLO</p> -->
        <div class="try-again" *ngIf="error; else success">
            <h2 style="color: #515151;">{{'MSG.SOMETHINK_WENT_WRONG' | translate}}</h2>
            <button class="lt set-btn-back-res mat-custom-btn btn-main-color" mat-flat-button (click)="init()"><mat-icon>refresh</mat-icon> Try again</button>
        </div>
        <ng-template #success>
            <div class="empty" *ngIf="isEmpty else notEmpty">
                <!-- <mat-icon>content_paste_off</mat-icon> -->
                <img src="./../../../../../assets/img/empty.png" alt="">
                <span>{{ 'LABEL.EMPTY_LIST' | translate }}</span>
            </div>
            <ng-template #notEmpty>
                <div class="order-list-wrapper">
                    <table
                        #table
                        mat-table
                        class="tr"
                        [dataSource]="orders">
                        <ng-container matColumnDef="ref">
                            <th mat-header-cell *matHeaderCellDef>{{ 'LABEL.NO.' | translate }}</th>
                            <td mat-cell *matCellDef="let element; index as i"> {{ element.index || i + 1 }} </td>
                        </ng-container>
                        <ng-container matColumnDef="pass">
                            <th mat-header-cell *matHeaderCellDef disableClear>{{'PAGE.ORDER.HOME.LIST.HEADER.PASS' | translate}}</th>
                            <td mat-cell *matCellDef="let element" class="unset-cell"> {{ 'SYSTEM.' + element.system | translate }} </td>
                        </ng-container>
                        <ng-container matColumnDef="type">
                            <th mat-header-cell *matHeaderCellDef disableClear>{{'PAGE.ORDER.HOME.LIST.HEADER.TYPE' | translate}}</th>
                            <td mat-cell *matCellDef="let element"> {{ getTicketType(element.tickets[0]?.ticket_type.num_day) | translate }} </td>
                            <!-- lang != 'en' ? -->
                        </ng-container>
                        <ng-container matColumnDef="quantity">
                            <th mat-header-cell *matHeaderCellDef>{{'PAGE.ORDER.HOME.LIST.HEADER.QUANTITY' | translate}}</th>
                            <td mat-cell *matCellDef="let element"> {{ element.tickets.length }} </td>
                        </ng-container>
                        <ng-container matColumnDef="price">
                            <th mat-header-cell *matHeaderCellDef>{{'PAGE.ORDER.HOME.LIST.HEADER.TOTAL_PRICE' | translate}}</th>
                            <td mat-cell *matCellDef="let element"> {{ element.total_price | currency }} </td>
                        </ng-container>
                        <ng-container matColumnDef="start">
                            <th mat-header-cell *matHeaderCellDef>{{'PAGE.ORDER.HOME.LIST.HEADER.VISIT_DATE' | translate}}</th>
                            <td mat-cell *matCellDef="let element"> {{ getMonth(element?.tickets[0]?.start_date) }} </td>
                        </ng-container>
                        <ng-container matColumnDef="expire">
                            <th mat-header-cell *matHeaderCellDef>{{'PAGE.ORDER.HOME.LIST.HEADER.EXPIRE_DATE' | translate}}</th>
                            <td mat-cell *matCellDef="let element">
                                {{ getMonth(element?.tickets[element.tickets.length - 1]?.expired_date) || '-'}}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="create">
                            <th mat-header-cell *matHeaderCellDef>{{'PAGE.ORDER.HOME.LIST.HEADER.CREATE_DATE' | translate}}</th>
                            <td mat-cell *matCellDef="let element"> {{ getMonth(element?.createdAt) }} </td>
                        </ng-container>
                        <ng-container matColumnDef="order_date">
                            <th mat-header-cell *matHeaderCellDef>{{'PAGE.ORDER.HOME.LIST.HEADER.ORDER_DATE' | translate}}</th>
                            <td mat-cell *matCellDef="let element">
                                {{ element?.order_date ?  getMonth(element?.order_date) : '-' }}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="payment">
                            <th mat-header-cell *matHeaderCellDef>{{'PAGE.ORDER.HOME.LIST.HEADER.STATUS' | translate}}</th>
                            <td mat-cell *matCellDef="let element">
                                <!-- <div  matRipple [ngClass]="{ chip: true, active: element.status == 'paid' }">
                                    {{ ('PAGE.ORDER.HOME.LIST.' + (element.status == 'paid' ? "PAID" : "UNPAID")) | translate }}
                                </div> -->
                                <div  matRipple [ngClass]="{ chip: true, active: element.status == 'paid', unpaid: element.status == PAYMENT_STATUS.UNPAID }">
                                    <!-- {{ ('PAGE.ORDER.HOME.LIST.' + (element.status == 'paid' ? "PAID" : "UNPAID")) | translate }} -->
                                    <ng-container *ngIf="element.status == PAYMENT_STATUS.PAID">
                                        {{ 'PAGE.ORDER.HOME.LIST.PAID' | translate }}
                                    </ng-container>
                                    <ng-container *ngIf="element.status == PAYMENT_STATUS.IN_PAYMENT">
                                        {{ 'PAGE.ORDER.HOME.LIST.IN_PAYMENT' | translate }}
                                    </ng-container>
                                    <ng-container *ngIf="element.status == PAYMENT_STATUS.UNPAID">
                                        {{ 'PAGE.ORDER.HOME.LIST.UNPAID' | translate }}
                                    </ng-container>
                                </div>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="action">
                            <th mat-header-cell *matHeaderCellDef style="text-align: right;">{{'PAGE.ORDER.HOME.LIST.HEADER.ACTION' | translate}}</th>
                            <td mat-cell *matCellDef="let element" class="action">
                                <div class="action-container">
                                    <button mat-button *ngIf="element.status == 'paid' && element.order_tx_number" (click)="downloadTickets(element)" class="download-ticket-btn">
                                        {{ 'LABEL.TICKETS' | translate }}
                                    </button>
                                    <button mat-button (click)="openViewDetail(element._id)" class="view-detail-btn">
                                        {{ 'LABEL.VIEW' | translate }}
                                    </button>
                                    <!-- <a *ngIf="element.status != 'paid'" mat-mini-fab class="btn edit" [routerLink]="element.isPaid ? null : 'edit'" [queryParams]="{ id: element.isPaid ? null : element._id }">
                                        <mat-icon>border_color</mat-icon>
                                    </a>
                                    <button *ngIf="element.status != 'paid'" mat-mini-fab class="btn delete" (click)="deleteOrder(element, table)">
                                        <mat-icon>delete</mat-icon>
                                    </button> -->
                                </div>
                            </td>
                        </ng-container>
                        <tr class="header-row" mat-header-row *matHeaderRowDef="TABLE_COL; sticky: true"></tr>
                        <tr mat-row *matRowDef="let row; columns: TABLE_COL;" @slide class="clickable-row" (click)="onRowClick(row._id)"></tr>
                    </table>
                </div>
                <mat-paginator
                    class="tr paginator"
                    showFirstLastButtons
                    [pageSize]="limit"
                    [length]="total"
                    [pageSizeOptions]="pageSize"
                    [pageIndex]="page - 1"
                    (page)="onPaginationChange($event)"
                ></mat-paginator>
            </ng-template>
        </ng-template>
    </div>
</div>
